import React from 'react';

import { Alert } from '@lightspeed/flame/Alert';

import { createReactRenderer } from 'helpers/react-renderer';

export const CustomAlert = ({ type, title, message, noCloseBtn = true }) => {
  return (
    <div className="cr-mb-4">
      <Alert type={type} title={title} noCloseBtn={noCloseBtn}>
        {message}
      </Alert>
    </div>
  );
};

const RenderedComponent = createReactRenderer({
  component: CustomAlert,
  selector: '[data-react-root="CustomAlert"]',
});

history.onChangeState(
  { name: 'admin.views.discount', tab: 'details', id: undefined },
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);
